import { useQuery } from "@tanstack/react-query";

import cookiesHelper from "../../helpers/cookies";

import { ISchool } from "../../interfaces/services"

import api from "../../services";

const useGetSchools = () => {
    const queryFn = async (): Promise<ISchool[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        const res = await api.get('misc/schools');
        return res.data;
    };

    return useQuery({
        queryKey: ['schools'],
        queryFn,
    });
}

export default useGetSchools;